// Don't overwrite jQuery if it's already loaded from Sprockets
// This preserves all jQuery plugins loaded via //= require in application.js
import $ from 'jquery';
import jQuery from 'jquery';

if (typeof window.$ === 'undefined' || typeof window.jQuery === 'undefined') {
  window.$ = $;
  window.jQuery = jQuery;
}

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Swal from 'sweetalert2'
import AnalyticsController from '../controllers/analytics_controller'

const application = Application.start()

// Starting a list of controllers so we can explicity list them instead of including all
// import GuestsFormController from '../controllers/guests/form_controller'
// import PhoneInputMaskController from '../controllers/phone_inputmask_controller'
// import Select2Controller from '../controllers/select2_controller'

// application.register('guests--form', GuestsFormController)
// application.register('phone-inputmask', PhoneInputMaskController)
// application.register('select2', Select2Controller)

// Corporate analytics: one controller class; payments_controller.js overrides params for analytics--payments
const CORPORATE_ANALYTICS_BASE_IDENTIFIERS = [
  'analytics--chat',
  'analytics--communities',
  'analytics--dating',
  'analytics--devices',
  'analytics--events',
  'analytics--maintenance',
  'analytics--marketplace',
  'analytics--packages',
  'analytics--pets',
  'analytics--residents',
  'analytics--appointments',
  'analytics--social',
  'analytics--units'
]

CORPORATE_ANALYTICS_BASE_IDENTIFIERS.forEach((identifier) => {
  application.register(identifier, AnalyticsController)
})

const context = require.context("../controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

// App styles (includes flatpickr.css via SCSS — required for production; a
// direct JS CSS import is extracted to a pack stylesheet that dashboard
// layouts never load). Overrides load after so selected-day colors win.
import '../stylesheets/application'
import '../stylesheets/flatpickr_overrides.sass'

// import Flatpickr
import Flatpickr from 'stimulus-flatpickr'

// Manually register Flatpickr as a stimulus controller
application.register('flatpickr', Flatpickr)

// Import SweetAlert2 and assign it to the global window object
window.Swal = Swal;

// ClientSideValidations (opt-in per form via validate: true)
import '../src/client_side_validations'
